// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".canvas-background[data-v-4c66118b]{position:absolute;top:0;left:0;width:100%;height:100%}.canvas-background canvas[data-v-4c66118b]{display:block}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
